import React, {Fragment} from "react";
import Grid from "@material-ui/core/Grid";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Typography from "@material-ui/core/Typography";

export default function Delivery(
  {
    deliveryMethodPrompt,
    deliveryMethodChoices,
    handleDeliveryMethod,
    deliveryMethod
  }) {
  return (
    <Fragment>
      <Grid spacing={1} container style={{marginTop: '5px', padding: '8px'}}>
        <Grid>
          <Typography variant={'subtitle1'}>
            {deliveryMethodPrompt}
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <RadioGroup
            value={deliveryMethod}
            onChange={(e) => {
              handleDeliveryMethod(e.target.value);
            }}
            name={'delivery-method-group'}
          >
            {
              deliveryMethodChoices.map(it =>
                <FormControlLabel key={it} value={it} label={it} control={<Radio color={"primary"}/>}/>
              )
            }
          </RadioGroup>
        </Grid>
      </Grid>
    </Fragment>
  )
}